module.exports = __webpack_public_path__ + "img/pd_C2.5 (_Dimension Characteristics_) .f7f074c2.png";